export const getDefaultConfig = () => {
  return {
    "discovery.wallet.method.default": "IFRAME/RPC",
  }
}
